import { Classmate } from "../interfaces/common";

export const initialGroup: Array<Classmate> = [
  { name: "Luis", active: true },
  { name: "Fede", active: true },
  { name: "Palm", active: true },
  { name: "Monti", active: true },
  { name: "April", active: true },
  { name: "Victoria", active: true },
  { name: "Shin Young (신영)", active: true },
  { name: "Eiji", active: true },
  { name: "Heeseo (희서)", active: true },
  { name: "Simge", active: true },
  { name: "Arturo", active: true },
  { name: "Jin (현진)", active: true },
  { name: "Grace", active: true },
  { name: "Lay", active: true },
  { name: "Maria Paz", active: true },
  { name: "Fernando", active: true },
  { name: "Minjun", active: true },
];

export const eyes: string[] = [
  "closed",
  "closed2",
  "crying",
  "cute",
  "glasses",
  "love",
  "pissed",
  "plain",
  "sad",
  "shades",
  "sleepClose",
  "stars",
  "tearDrop",
  "wink",
  "wink2",
];

export const mouth: string[] = [
  "cute",
  "drip",
  "faceMask",
  "kissHeart",
  "lilSmile",
  "pissed",
  "plain",
  "sad",
  "shout",
  "shy",
  "sick",
  "smileLol",
  "smileTeeth",
  "tongueOut",
  "wideSmile",
];
